import { createSelector } from 'reselect'

const getSidePanelOpen = state => state.ui.isSidePanelOpen
const getMenuItemSelected = state => state.ui.menuItemSelected

export default createSelector(
  [getSidePanelOpen, getMenuItemSelected],
  (isSidePanelOpen, menuItemSelected) => {

    return isSidePanelOpen && menuItemSelected === 'chat'

  })
